import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion'
import { useAccount } from 'wagmi';

const Mint = () => {

    const { isConnected } = useAccount();
    const [ classSet, setClassSet ] = useState('initial');

    return (
        <>

            <h1 className="title">
                    <Link to="/">Web3</Link>
            </h1>

            <motion.div className="container Mint"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >

                <main className="main">

                    {isConnected ? (
                        <div className="page-content">
                            <h3>Mint</h3>
                            <p>coming soon</p>
                        </div>
                    ) : !isConnected && (
                        <div className="page-content center">
                            <h6>Connect your wallet to access this page.</h6>
                        </div>
                    )}

                </main>

            </motion.div>
        </>
    );
}

export default Mint
